import * as Sentry from '@sentry/react'

/** Initialize Sentry error tracking and performance monitoring. */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN

  if (!dsn) {
    console.warn('Sentry DSN not provided — Sentry will not be initialized.')
    return
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_ENVIRONMENT ?? 'development',
    release: import.meta.env.VITE_RELEASE_SHA ?? 'local',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: import.meta.env.VITE_ENVIRONMENT === 'production' ? 0.1 : 1.0,
    // A Safari extension rejects with `{}` and dispatches a synthetic `unhandledrejection` CustomEvent; neither carries anything to act on
    ignoreErrors: [
      /Event `CustomEvent` \(type=unhandledrejection\) captured as promise rejection/,
      /Object captured as promise rejection with keys: \[object has no keys\]/,
    ],
  })
}
